<transition name="modal">
  <div class="modal-mask task-modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <app-sub-navigation-bar
          back-label="Back to task"
          @back="$emit('close')"
        />

        <div class="task-modal-shell">
          <div class="task-modal-body">
            <h4 class="task-modal-title">Select Product</h4>

            <div class="ui form task-modal-product-search">
              <div class="field">
                <app-field-label>Search products</app-field-label>
                <app-text-input
                  icon="search"
                  :model-value="searchText"
                  placeholder="Search Reece / product catalogue"
                  @update:model-value="onSearchInput"
                />
              </div>
            </div>

            <app-loader v-if="loading"></app-loader>

            <div v-else class="task-modal-product-grid">
              <article
                v-for="product in displayProducts"
                :key="product.id || product.uuid || product.description"
                class="task-modal-product-card"
                :class="{ 'task-modal-product-card--customer-supplied': isCustomerSuppliedProduct(product) }"
              >
                <div class="task-modal-product-card__image">
                  <img
                    v-if="getImageUrl(product)"
                    :src="getImageUrl(product)"
                    :alt="product.description || ''"
                  />
                  <img
                    v-else
                    src="../../../../assets/img/no-image-available.jpg"
                    alt=""
                  />
                </div>
                <div class="task-modal-product-card__body">
                  <h2 class="task-modal-product-card__title text-body-large-strong">{{ productDisplayName(product) }}</h2>
                  <p v-if="!isCustomerSuppliedProduct(product) && (product.primary_supplier_code || product.supplier_id)" class="task-modal-product-card__id">
                    ID: {{ product.primary_supplier_code || product.supplier_id }}
                  </p>
                  <p class="task-modal-product-card__id">
                    <template v-if="isCustomerSuppliedProduct(product)">No product cost</template>
                    <template v-else>${{ formatPrice(product.sell_price) }}</template>
                  </p>
                  <button
                    type="button"
                    class="ui secondary button task-modal-product-card__select"
                    @click="selectProduct(product)"
                  >Select</button>
                </div>
              </article>

              <p
                v-if="displayProducts.length <= 1 && searchText.length >= 3 && !loading"
                class="task-modal-product-hint text-body-medium"
              >
                No catalogue products found. You can still select Customer Supplied.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
